/**
 * manpowerConstants.js - tunables for the manpower calendar: how many weeks
 * the week view shows, and the localStorage keys its offline cache lives
 * under.
 *
 * The REGION_LABEL / ACTIVITY_LABEL maps that used to sit here are gone. They
 * translated the Manpower Planning sheet's codes ("P-Proc", "(SA)") into
 * words underneath every engineer's name, so the grid was captioned with
 * vocabulary nobody using it had chosen. Labels on the calendar are the ones
 * people type.
 */

export const WEEKS_VISIBLE = 8;
export const LS_COLOR_KEY = 'manpower:projectColors';
// Offline cache of the schedule: { 'EngineerName|YYYY-MM-DD': 'ProjectName' | null }.
// The server copy is authoritative; this is only so a refresh while the API is
// unreachable doesn't lose work.
export const LS_EDITS_KEY = 'manpower:edits';
// Cache of the project labels people have typed.
export const LS_CUSTOM_PROJ_KEY = 'manpower:customProjects';

// Visual treatment for "no project assignment" cells — no project color,
// just a subtle dashed placeholder so the grid stays readable.
export const EMPTY_STYLE = { bg: 'transparent', border: '1px dashed #E0E0E0' };
